
<div class="row">
<div *ngIf="customerInfo.customerCode" class="col-md-12 customer-info text-primary">
 {{customerInfo.customerCode}} - {{customerInfo.name}} 
</div>
</div>
